import { render } from "./SignosVitales.vue?vue&type=template&id=30168f15&scoped=true"
import script from "./SignosVitales.vue?vue&type=script&lang=js"
export * from "./SignosVitales.vue?vue&type=script&lang=js"

import "./SignosVitales.vue?vue&type=style&index=0&id=30168f15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30168f15"]])

export default __exports__